const cronograma = [
  {
    dia: 'Terça-feira (16/08)',
    atividades: [
      {
        tipo: 'credenciamento',
        titulo: '',
        ministrante: '',
        desc: 'Horário disponível para que os inscristos possam fazer o processo de credenciamento',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '07:30 - 09:30',
      },
      {
        tipo: 'Palestra',
        titulo: 'Apresentação institucional do PET',
        ministrante: 'PET Computação UFC',
        desc: 'Nessa palestra os membros do PET irão falar um pouco sobre o PET, oque eles fazem e ex-PETianos contaram as suas experiências.',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '09:10 - 10:00',
      },
      {
        tipo: 'Palestra',
        titulo: 'Machine learning com a empresa QI Tech',
        ministrante: 'CTO QI Tech',
        desc: 'Já imaginou como funciona o sistema financeiro brasileiro em termos de linhas de códigos? A QI Tech é uma empresa de tecnologia com licença de instituição financeira que tem como missão ser a AWS dos serviços financeiros no Brasil, oferecendo produtos, APIs e tecnologia que viabiliza produtos dos nossos clientes, grandes empresas brasileiras, como por exemplo Vivo, Unidas, Magazine Luiza e outros. Utilizamos machine learning e tecnologia de ponta para construir nossos produtos e vamos dividir com você um pouco de como lidamos com tecnologia no dia a dia, especificamente como lidamos e fazemos modelos de machine learning que ajudam nossos clientes a poupar milhões de reais evitando fraudes. Quer saber como fazemos a preparação dos dados? Quais tipos de modelos usamos? Como é nosso pipeline de treinamento de modelos? Venha conversar com a gente!!',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '09:10 - 10:00',
      },
      {
        tipo: 'Palestra',
        titulo: 'Computação forense com o professor Marcos Monteiro',
        ministrante: 'Marcos Monteiro',
        desc: 'O prof. Marcos Monteiro é presidente da Associação Nacional de Peritos em Computação Forense (APECOF); Organizador e Autor do Livro “Informática Forense” da coleção Tratado de Perícias Forenses da editora LEUD; Coordenador de Segurança da Informação e Computação Forense da Comissão de Direito Digital da OAB do estado de São Paulo; possui certificação Internacional de Perito Forense - EC-Council (CHFI - Computer Hacking Forensics Investigator); proprietário da empresa Marcos Monteiro - Computação Forense;Coordenador e Professor de várias instituições de pós graduação.',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '10:20 - 11:10',
      },
    ],
  },
  {
    dia: 'Quarta-feira (17/08)',
    atividades: [
      {
        tipo: 'credenciamento',
        titulo: '',
        ministrante: '',
        desc: 'Horário disponível para que os inscristos possam fazer o processo de credenciamento',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '07:30 - 09:30',
      },
      {
        tipo: 'Palestra',
        titulo: 'Fazendo um Web Scraping no site de seminovos da Unidas',
        ministrante: 'Alessandro Feitoza',
        desc: 'E então, tá a fim de comprar ou vender um carro e quer fazer um levantamento assertivo quanto ao valor dele no mercado Nessa palestra veremos como é simples fazer um web scraping coletando informações de ofertas de carros no site da Unidas Seminovos. Ao final do processo teremos um dataset com dados riquíssimos quanto a valores matemáticos capazes de predizer o valor de um automóvel através de algumas variáveis Obs: A empresa Unidas já é bastante conhecida por alugar automóveis para pessoas físicas, mas o que muita gente não sabe é que esse não é a única fonte de renda da empresa, já que quando o carro alcança determinado período de uso ela o coloca a venda',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '09:10 - 10:00',
      },
      {
        tipo: 'Palestra',
        titulo: 'Aprendizagem de Máquina para Salvar Vidas',
        ministrante: 'Professor João Paulo',
        desc: 'Motivações e oportunidades de pesquisa no campo da Inteligência Artificial Aplicada à Saúde, com projetos em desenvolvimento e parcerias estabelecidas.',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '10:20 - 11:10',
      },
    ],
  },
  {
    dia: 'Quinta-feira (18/08)',
    atividades: [
      {
        tipo: 'credenciamento',
        titulo: '',
        ministrante: '',
        desc: 'Horário disponível para que os inscristos possam fazer o processo de credenciamento',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '07:30 - 09:30',
      },
      {
        tipo: 'Palestra',
        titulo: 'Representatividade feminina na área de ti e sobre as pyladies',
        ministrante: 'Andreza Fernandes',
        desc: 'PyLadies é uma comunidade mundial que foi trazida ao Brasil com o propósito de ajudar mais e mais mulheres a se tornarem participantes ativas e líderes na comunidade open source Python.',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '08:00 - 08:50',
      },
      {
        tipo: 'Palestra',
        titulo: 'Ciência de dados',
        ministrante: 'Germano',
        desc: '',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '09:10 - 10:00',
      },
      {
        tipo: 'Palestra',
        titulo: 'Transformando ideias em negócios inovadores por meio da tecnologia',
        ministrante: 'Jerffeson Teixeira de Souza',
        desc: 'Nessa palestra vamos discutir os desafios que envolvem o desenvolvimento de negócios inovadores por meio da tecnologia, apresentando o processo de transformação de ideas em empresas de sucesso.',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '10:20 - 11:10',
      },
    ],
  },
  {
    dia: 'Sexta-feira (19/08)',
    atividades: [
      {
        tipo: 'credenciamento',
        titulo: '',
        ministrante: '',
        desc: 'Horário disponível para que os inscristos possam fazer o processo de credenciamento',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '07:30 - 09:30',
      },
      {
        tipo: 'Palestra',
        titulo: 'RSI',
        ministrante: 'RSI',
        desc: 'O Projeto de Extensão titulado "Residência em Segurança da Informação (RSI)" tem como objetivo prestar serviços gratuitos em segurança de TI (Tecnologia da Informação) às unidades acadêmicas e administrativas da UFC, bem como empresas de pequeno e médio porte, além de proporcionar experiência nesta área para alunos dos cursos de Bacharelado em Ciência da Computação e Engenharia da Computação da Universidade Federal do Ceará (UFC).',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '09:10 - 10:00',
      },
      {
        tipo: 'coffe-break',
        titulo: '',
        ministrante: '',
        desc: 'Um pequeno intervalo para os participantes no qual os participantes podem conversar, trocar ideias, criar novos contatos e, obviamente, fazer um bom lanche',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '09:10 - 10:00',
      },
      {
        tipo: 'Palestra',
        titulo: 'Detecção de fake news com machine learning',
        ministrante: 'José Maria da Silva Monteiro Filho',
        desc: 'Nos últimos anos, a disseminação em larga escala de desinformação por meio das mídias sociais tornou-se uma questão crítica, prejudicando a confiabilidade de informações legítimas, a estabilidade social, a democracia e a saúde pública. Em muitos países em desenvolvimento, como Brasil, Índia e México, uma das principais fontes de desinformação é o aplicativo de mensagens WhatsApp. Em fevereiro de 2020, a pesquisa Panorama Mobile Time/Opinion Box sobre mensagens móveis no Brasil revelou que o WhatsApp estava instalado em 99% dos smartphones brasileiros. Entre os usuários do aplicativo, 98% afirmaram acessar todos os dias ou quase todos os dias. Nesse contexto, o WhatsApp oferece um recurso importante: os grupos públicos. Muitos desses grupos têm sido usados ​​para disseminar informações erradas, especialmente como parte de campanhas políticas ou ideológicas articuladas. Apesar desse cenário, devido à natureza de mensagens privadas do WhatsApp, poucos métodos foram desenvolvidos explicitamente para investigar o fenômeno da desinformação nessa plataforma. Este tutorial fornece uma visão geral dos desenvolvimentos recentes no monitoramento da disseminação de desinformação, detecção automática de desinformação, além da identificação de bots e propagadores de desinformação. Além disso, fornecemos uma visão geral dos principais problemas em aberto associados ao fenômeno da desinformação e examinamos brevemente algumas das soluções existentes. Esperamos que nosso tutorial possa ajudar os pesquisadores a entender melhor a propagação de desinformação no Brasil e usar métodos de ciência de dados para enfrentar esse fenômeno crítico. José Maria da Silva Monteiro Filho: Mestre em Ciência da Computação pela Universidade Federal do Ceará (UFC), Brasil, em 2001. Em 2008 recebeu o título de Doutor pela Pontifícia Universidade Católica do Rio de Janeiro (PUC-Rio), Brasil. Está na Universidade Federal do Ceará (UFC) desde 2010 como professor titular e pesquisador do grupo de pesquisa ARIDA (Advanced Research In Database). Publicou mais de 50 artigos em revistas internacionais e actas de conferências e coordenou vários projectos de investigação e desenvolvimento. Seus atuais interesses de pesquisa incluem Data Science, Big Data e desinformação.',
        local: 'Auditório do Centro de Ciências, bloco 902',
        hora: '10:20 - 11:10',
      },
    ],
  },
];

module.exports = cronograma;
